import React, {useContext} from "react";
import styles from "./layerSelection/LayerSelection.module.scss"
import appContext from "../../../../../context/appContext";

const LayerSelection = () => {

  const context = useContext(appContext)

  const handleSetActiveLayerInfo = (layerData) => {
    const copySidebarData = [...context.handleLayerList()]
    const newSidebarData = copySidebarData.map(item => {
      if (item.layer === layerData.layer) {
        return {...item, selected: true}
      } else {
        return {...item, selected: false}
      }
    })
    context.handleLayerList(newSidebarData)
    context.handleIsClickedOnLayerSelection(true)
  }

  React.useEffect(() => {
    if (context.handleIsFiltersModalOpen() && context.handleLayerList().length && !context.handleLayerList().some(item => item.selected)) {
      handleSetActiveLayerInfo(context.handleLayerList()?.find(item => item.type === "mainLayer"))
    }
  }, [context.handleIsFiltersModalOpen()])

  return (
    <div className={styles.LayerSelection}>
      <div className={styles.title}>
        Layer Selection
      </div>
      <div className={styles.layersList}>
        <ul>
          {
            context?.handleLayerList()?.length && context.handleLayerList().map(layer => <li onClick={() => handleSetActiveLayerInfo(layer)} className={context?.handleLayerList()?.find(item => item.selected)?.layer === layer.layer && styles.active}>
              <div className={styles.bullet} style={{backgroundColor: layer.color}}>
              </div>
              <div className={styles.layerInfo}>
                <div className={styles.layerId}>
                  {layer.layer_number}
                </div>
                <div className={styles.layerName}>
                  {layer.layer_name}
                </div>
              </div>
            </li>
            )
          }
        </ul>
      </div>
    </div>
  )
}

export default LayerSelection